<template>
  <v-card class="home-banner">
    <v-card-text :class="['pt-8', {'mdAndUp': $vuetify.breakpoint.mdAndUp}]">
      立刻登記成為機場員工會所會員，即可免費試用會所設施至2023年1月15日。敬請關注我們，以獲得更多會所的精彩活動資訊及優惠。
      <br><br>
      Register as member of HKIA Staff Clubhouse to enjoy free usage of Clubhouse facilities till 15 January 2023. Stay tuned and get ready for the exciting activities and offers of the Clubhouse.
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'HomeBanner',
}
</script>

<style lang="less">
.home-banner {
  .mdAndUp {
    font-size: 100%;
    line-height: 140%;
  }
}
</style>
